import { List } from 'immutable';
import { Ingredients } from 'records/Ingredient';
import BaseList from 'records/BaseList';

import {
  CUSTOM_INGREDIENTS_ASYNC_ACTION_START,
  CUSTOM_INGREDIENTS_ASYNC_ACTION_ERROR,
  CUSTOM_INGREDIENTS_ASYNC_ACTION_SUCCESS,
  CUSTOM_INGREDIENTS_RESET_STATE,
} from 'actions/customIngredients';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [CUSTOM_INGREDIENTS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [CUSTOM_INGREDIENTS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [CUSTOM_INGREDIENTS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: Ingredients(action.data),
    });
  },
  [CUSTOM_INGREDIENTS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function customIngredients(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
